<template>
    <div class="row">
      <!-- Card for meetingslot and description input -->
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <div class="card-body">
            <div>
              <h3 class="card-title">{{ $t('Timeslot and description') }}</h3>
            </div>
            <div class="form-horizontal p-t-0">

              <!-- Input of meetingslot -->
              <div class="form-group row">
                <label for="slot" class="col-sm-12 control-label">{{ $t('Choose slot') }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <select v-model="selectedMeeting" class="form-control btn-rounded" id="slot">
                      <option disabled value="0">{{ $t("Please select a timeslot") }}</option>
                      <option v-for="slot in timeslots" :value="slot.uid">
                        {{ slot | slotFilter }} /
                        <template v-if="typeof slot.Problems !== 'undefined' && slot.Problems.length > 0">
                          {{ slot.Problems.length }} {{ $t("Problems attached")}}
                        </template>
                        <template v-else>
                          {{ $t("Free") }}
                        </template>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Description input -->
              <div v-bind:class="{'error' : form_valid_info.description}"  class="form-group row">
                <label for="meeting-description" class="col-sm-12 control-label">{{ $t('Description of this meeting') }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <textarea v-model="description" id="meeting-description" class="form-control" rows="5" ></textarea>
                  </div>
                  <div class="help-block">
                    <ul role="alert">
                      <li v-for="msg in form_valid_info.description"><small>{{ msg }}</small></li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="ml-auto">
                <button type="button" class="btn btn-sm btn-rounded btn-info" v-on:click="saveChanges"><i class="ti-check"></i> {{ $t('Save changes') }}</button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Card for adding problems to the meeting -->
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div>
                <h3 class="card-title">{{ $t('Discussed problems') }}</h3>
              </div>
              <div class="ml-auto">
                <button type="button" class="btn btn-sm btn-rounded btn-info" @click="showProblem = !showProblem"><i class="ti-plus"></i> {{ $t('Add problem') }}</button>
              </div>
            </div>

            <!-- Problems table -->
            <div v-if="addedProblems.length > 0" class="table-responsive m-t-20">
              <table class="table vm no-th-brd pro-of-month">
                <tbody>
                <tr v-for="problem in addedProblems">
                  <td>
                    <h5 class="font-bold">{{ problem.name }}</h5>
                    <small v-if="(typeof problem.kpi_name) === 'string'" class="text-muted">{{ $t("KPI") }} - {{ problem.kpi_name | ucFirst }}</small>
                  </td>
                  <td class="text-right">
                    <a v-on:click="removeProblem(problem.problem_uid)">{{ $t('Remove') }}</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <!-- Action input -->
            <div v-if="showProblem" class="d-flex">
              <div class="col-sm-12 col-xs-12">
                <div class="p-t-20">
                  <div v-bind:class="{'error' : false}" class="form-group row">
                    <label for="kpi-select" class="col-sm-12 control-label">{{ $t('Select a KPI') }}</label>
                    <div class="col-sm-8 kpi-input">
                      <div class="input-group">
                        <select v-model="selectedKPI" name="kpi-select" id="kpi-select" class="form-control btn-rounded">
                          <option v-for="kpi in kpiData" :value="kpi">
                            {{ kpi.name }}
                          </option>
                        </select>
                      </div>
                      <div class="input-group" v-show="problemData.length">
                        <select v-model="problemToAdd" name="kpi" id="problem-title" class="form-control btn-rounded">
                          <option selected disabled :value="{}">{{ $t("Select a problem") }}</option>
                          <option v-for="problem in problemData" :value="{kpi_name : selectedKPI.name, uid : problem.uid, problem_name : problem.name}">
                              {{ problem.depth | depthFilter }}{{ problem.name }}
                            </option>
                          </optgroup>
                        </select>
                      </div>
                      <div class="input-group" v-show="!problemData.length && Object.keys(selectedKPI).length">
                          {{ $t("No problems") }}
                      </div>

                      <div class="help-block">
                        <ul role="alert">
                          <li v-for="msg in null"><small>{{ msg }}</small></li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-sm-1">
                      <img src="../assets/img/loader.gif" v-show="loadingKPI"/>
                      <img src="../assets/img/loader.gif" class="problems-loading-spinner" v-show="loadingProblems" />
                    </div>
                    <div class="col-sm-3 ml-auto add-button-container" v-show="problemData.length">
                      <button type="submit" class="btn btn-sm btn-rounded btn-info" v-on:click="addProblem">{{ $t('Add') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <invitees-widget :invitees="attendeeData" :meeting_uid="meeting_uid"></invitees-widget>

      </div>
    </div>
</template>

<script>
  import apiHelper from '../mixins/APIHelper';
  import InviteeWidget from './InviteeWidget';

  export default {
    name: "PlanMeeting",
    components: {
      "invitees-widget": InviteeWidget
    },
    data: function() {
      return {
        kpiData: [],
        problemData: [],
        addedProblems: [],
        problemToAdd: {},
        meetingData:[],
        attendeeData: [],
        meeting_uid: this.$route.params.id,
        selectedMeeting: 0,
        selectedKPI: {},
        timeslots: [],
        description: "",
        showProblem: false,
        form_valid_info: [],
        meetingProblem: null,
        previousMeeting: "",
        loadingKPI: false,
        loadingProblems: false,
      }
    },
    created() {
      this.getProblemData();
      this.findTimeslots();

      if (this.meeting_uid !== undefined) {
        this.selectedMeeting = this.meeting_uid;
      }

      this.$parent.title = this.$t("Plan meeting");
    },
    beforeDestroy() {
      this.$parent.title = "";
    },
    methods: {
      // Grabs all the KPI's and their problems
      getProblemData: function() {
        let vm = this;
        let first_date = moment(new Date(new Date().getFullYear(), 0, 1)).format('YYYY-MM-DD');
        let last_date = moment(new Date(new Date().getFullYear(), 11, 31)).format('YYYY-MM-DD');
        let years = {
          date_start: first_date,
          date_end: last_date
        };
        console.log("Started requesting KPIs");
        this.loadingKPI = true;
        apiHelper.getResource("/api/user/{uid}/kpi").then((data) => {
          vm.kpiData = data;

          if (vm.$route.query.kpiId !== undefined) {
            vm.selectedKPI = vm.kpiData.find((kpi) => kpi.uid === vm.$route.query.kpiId);
            vm.showProblem = true;

            apiHelper.getResource("/api/kpi/" + vm.selectedKPI.uid + "/problem-causes", years).then((problemData) => {
              console.log(vm.$route.query.problem, problemData )
              let paramProblem = problemData.find((problem) =>  problem.uid == vm.$route.query.problem );
              vm.problemToAdd = {kpi_name : vm.selectedKPI.name, uid : paramProblem.uid, problem_name : paramProblem.name};
            });
          }
          vm.loadingKPI = false;
          console.log(vm.selectedKPI, vm.$route.query.kpiId)
          console.log("Finished requesting KPI's");
        });
      },

      // Method for adding the selected problem to the meeting
      addProblem: function () {
        let vm = this;
        if (Object.keys(vm.problemToAdd).length) {
          let uid = vm.meeting_uid;
          let data_to_send = {
            "kpi_problem_cause_uid" : vm.problemToAdd.uid
          };

          apiHelper.postResource('/api/meeting/' + uid + '/problem', data_to_send).then((data) => {
            if (data.status !== 409) {
              let problem = {
                name : vm.problemToAdd.problem_name,
                kpi_name : vm.problemToAdd.kpi_name,
                problem_uid : vm.problemToAdd.uid,
                problem_id : data.meeting_kpi_problem_cause_id,
                meeting_id : data.meeting,
                kpi_problem_cause : data.kpi_problem_cause
              };

              vm.addedProblems.push(problem);

              vm.problemToAdd = {};
            }
          });
        } else {
          vm.$notify({
            group: "notification",
            title: vm.$t("Something went wrong.."),
            text: vm.$t("Please select a problem."),
            type: 'error'
          });
        }
      },

      // Method for removing the selected problem to the meeting
      removeProblem: function (id) {
        let vm = this;

        // if (id !== vm.meetingProblem.problem_uid) {
          apiHelper.delResource("/api/meeting/" + vm.meeting_uid + "/problem/" + id).then((data) => {
            if (data === 1) {
              vm.$notify({
                group: "notification",
                title: vm.$t("Success"),
                text: vm.$t("Removed the problem succesfully."),
                type: 'success'
              });

              for (let i = 0; i < vm.addedProblems.length; i++) {
                let problem = vm.addedProblems[i];
                // console.log(id, problem, vm.problemToAdd.uid)
                if (problem.problem_uid === id) {
                  vm.addedProblems.splice(i, 1);
                  break;
                }
              }
            } else {
              vm.$notify({
                group: "notification",
                title: vm.$t("Something went wrong.."),
                text: vm.$t("Something went wrong while removing the problem."),
                type: 'error'
              });
            }
          });
        // }else{
        //
        //   for (let i = 0; i < vm.addedProblems.length; i++) {
        //     let problem = vm.addedProblems[i];
        //     if (problem.problem_uid === vm.meetingProblem.problem_uid) {
        //       vm.addedProblems.splice(i, 1);
        //       break;
        //     }
        //   }
        // }
      },

      // Grabs the meeting data to get the attendees and problems
      getMeetingData: function() {
        let vm = this;
        let args = {
          "include": "Problems,MeetingProblems,MeetingNorm,Attendees"
        };

        // Clear the old meeting data
        vm.addedProblems = [];
        vm.attendeeData = [];


        // Add the passed problem
        if(vm.meetingProblem !== null){
          vm.addedProblems.push(vm.meetingProblem);
          let data_to_send = {
            "kpi_problem_cause_uid" : vm.meetingProblem.uid
          };

          apiHelper.postResource('/api/meeting/' + vm.meeting_uid + '/problem', data_to_send).then((data) => {
            if(vm.previousMeeting !== ""){
              apiHelper.delResource("/api/meeting/" + vm.meeting_uid + "/problem/" + vm.previousMeeting).then(function (data) {
                vm.previousMeeting = vm.meeting_uid;
              })
            }
          });
        }

        console.log("Started loading meeting details");
        apiHelper.getResource("/api/meeting/" + vm.meeting_uid, args).then((data) => {
          console.log("Done loading meeting details")
          if ("data" in data.MeetingProblems) {

            for (let i = 0; i < data.MeetingProblems.data.length; i++) {
              let problem = {
                name: data.Problems.data[i].name,
                kpi_name: data.Problems.data[i].kpi,
                problem_uid: data.Problems.data[i].uid,
                problem_id: data.MeetingProblems.data[i].meeting_kpi_problem_cause_id,
                meeting_id: data.MeetingProblems.data[i].meeting,
                kpi_problem_cause: data.MeetingProblems.data[i].kpi_problem_cause
              };

              vm.addedProblems.push(problem);
            }
          }

          if ("data" in data.Attendees) {
            let normUsers = [];
            let attendeeUIDS = [];

            for (let i = 0; i < data.Attendees.data.length; i++) {
              attendeeUIDS.push(data.Attendees.data[i]['User']['uid']);
            }

            for (let i = 0; i < data.MeetingNorm.Invitees.data.length; i++) {
              normUsers.push(data.MeetingNorm.Invitees.data[i]['uid']);
            }

            for (let i = 0; i < data.MeetingNorm.Invitees.data.length; i++) {
              if (attendeeUIDS.indexOf(data.MeetingNorm.Invitees.data[i]['uid']) === -1) {
                let attendee = data.MeetingNorm.Invitees.data[i];
                attendee['in_norm'] = true;
                attendee['meeting_user_id'] = null;
                vm.attendeeData.push(attendee);
              }
            }

            for (let i = 0; i < data.Attendees.data.length; i++) {
              let attendee = data.Attendees.data[i];
              attendee['User']['meeting_user_id'] = attendee['meeting_user_id'];

              let index = normUsers.indexOf(attendee['User']['uid']);
              attendee['User']['in_norm'] = index !== -1;

              vm.attendeeData.push(attendee['User']);
            }
          } else {
            for (let i = 0; i < data.MeetingNorm.Invitees.data.length; i++) {
              let attendee = data.MeetingNorm.Invitees.data[i];
              attendee['in_norm'] = true;
              attendee['meeting_user_id'] = null;
              vm.attendeeData.push(attendee);
            }
          }

          vm.description = data.description;

          if((Object.keys(vm.problemToAdd)).indexOf('problem') !== -1){
            vm.addProblem();
          }
          console.log("Done rendering meeting details");
        });
      },

      // Finds the timeslots
      findTimeslots: function () {
        let vm = this;

        apiHelper.getResource("/api/user/{uid}/meeting-time-slots").then((data) => {
          vm.timeslots = data;
          // Fix, necessary for mobile
          window.scrollTo(0,0);
        });
      },

      saveChanges: function () {
        let vm = this;

        if (vm.meeting_uid === undefined) {
          vm.$notify({
            group: "notification",
            title: vm.$t("Error"),
            text: vm.$t("Please make sure a meeting is selected."),
            type: 'error'
          });
          return;
        }

        let args = {
          "include": "Attendees,Problems"
        };

        apiHelper.getResource("/api/meeting/" + vm.meeting_uid, args).then((data) => {
          let attendees = data.Attendees.data;
          let problems = data.Problems.data;


          if (problems === undefined) {
            vm.$notify({
              group: "notification",
              title: vm.$t("Error"),
              text: vm.$t("You need at least 1 problem for this meeting."),
              type: 'error'
            });
            return;
          } else if (attendees === undefined) {
            vm.$notify({
              group: "notification",
              title: vm.$t("Error"),
              text: vm.$t("You need at least 1 attendee for this meeting."),
              type: 'error'
            });
            return;
          } else {
            // Check if the facilitator has been checked
            apiHelper.getResource("/api/meeting/" + vm.meeting_uid + "/view").then((data) => {
              let facilitator = data['Facilitator']['uid'];
              let found = false;

              for (let i = 0; i < attendees.length; i++) {
                if (facilitator === attendees[i]['User']['uid']) {
                  found = true;
                }
              }

              if (!found) {
                vm.$notify({
                  group: "notification",
                  title: vm.$t("Error"),
                  text: vm.$t("Please make sure the facilitator has also been checked."),
                  type: 'error'
                });
                return;
              } else {

                let data_to_send = {
                  "description": vm.description
                };

                apiHelper.putResource("/api/meeting/" + vm.meeting_uid, data_to_send).then((data) => {
                  if (data.status !== 422) {
                    vm.$notify({
                      group: "notification",
                      title: vm.$t("Success"),
                      text: vm.$t("Meeting saved successfully"),
                      type: 'success'
                    });
                    vm.form_valid_info = [];
                  } else {
                    let keys = Object.keys(data.title);

                    for (let i = 0; i < keys.length; i++) {
                      let k = keys[i].replace(/-/g, "_");
                      data.title[k] = data.title[keys[i]];
                      if (k.indexOf('_') !== -1) {
                        delete data.title[keys[i]];
                      }
                    }

                    vm.form_valid_info = data.title;
                  }
                });
              }
            });
          }
        });
      }
    },
    watch: {
      selectedMeeting: function (value) {
        this.meeting_uid = value;
        this.addedProblems = [];
        this.attendeeData = [];

        this.getMeetingData();

        if (Object.keys(this.problemToAdd).length){
          this.addProblem();
        }
      },
      selectedKPI: function(value) {
        if (Object.keys(value).length) {
          let first_date = moment(new Date(new Date().getFullYear(), 0, 1)).format('YYYY-MM-DD');
          let last_date = moment(new Date(new Date().getFullYear(), 11, 31)).format('YYYY-MM-DD');
          let years = {
            date_start: first_date,
            date_end: last_date
          };
          let vm  = this;
          vm.loadingProblems = true;
          apiHelper.getResource("/api/kpi/" + value.uid + "/problem-causes", years).then((data) => {
            // Start loading the next, we are done
            console.log("Finished requesting KPI " + value.uid);
            vm.loadingProblems = false;
            if (data.length > 0) {
              vm.problemData = data;
              console.log("Finished rendering KPI");
              // Fix, necessary for mobile
              window.scrollTo(0,0);
            } else {
              vm.problemData = [];
            }
          });
        }
      }
    },
    computed: {
      // Find the height for the scrollbox of the actions
      // findHeight: function () {
      //   if (this.addedProblems.length > 2) {
      //     return "overflow-y: scroll; height: 240px;"
      //   } else {
      //     let h = String(this.addedProblems.length * 80);
      //     return "overflow-y: hidden; height: " + h + "px;";
      //   }
      // }
    }
  }
</script>

<style scoped>
  #meeting-description{
    width: 100%;
  }

  .kpi-input > .input-group:first-child {
    margin-bottom: 16px;
  }

  .add-button-container > button {
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .problems-loading-spinner {
    position: absolute;
    bottom: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlanMeeting.vue